/* 🎨 STYLES */
import { Container, ContainerContent, Bar, BarFill, BarContent, BallContainer, Ball, BallColor } from "./styles";

/* 🔧 UTILS */
import { GetCardsColor } from "../../../../util/Colors";

/**
 * Componente para a Barra
 * @param {int} valor valor
 * @param {int} Max valor maximo
 * @param {int} Min valor minimo
 * @returns {ReactComponentElement} 
 */
const CardBar = ({valor, Color, Focus}) =>{
    const altura = ((valor)/100)*100 > 100 ? 100 : ((valor)/100)*100;

    let color = GetCardsColor(Color)

    return (
        <Container>
            <ContainerContent>
                <Bar $isfocus={Focus}>
                    <BarFill>
                        <BarContent $value={altura} color={color.background}/>
                        <BallContainer $value={altura}>
                            <Ball $isfocus={Focus}/>
                            <BallColor color={color.ball} />
                        </BallContainer>
                    </BarFill>
                </Bar>
            </ContainerContent>
        </Container>
    );
}

export default CardBar;

